import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isAuthenticated: boolean;
  user: any;
  loading: boolean;
  otpSent: boolean;
  isLocked: boolean;
  lockExpiry?: number;
  tempEmail?: string;
  forgotPasswordToken?: string;
  tempToken: string | null;
}

const initialState: AuthState = {
  isAuthenticated: !!localStorage.getItem("token"),
  user: JSON.parse(localStorage.getItem("user") || "null"),
  loading: false,
  otpSent: false,
  isLocked: false,
  lockExpiry: undefined,
  tempEmail: undefined,
  forgotPasswordToken: undefined,
  tempToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<{ user: any; token: string }>) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("user", JSON.stringify(action.payload.user || {}));
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTempEmail: (state, action: PayloadAction<string>) => {
      state.tempEmail = action.payload;
    },
    setOtpSent: (state, action: PayloadAction<boolean>) => {
      state.otpSent = action.payload;
    },
    setForgotPasswordToken: (state, action: PayloadAction<string>) => {
      state.forgotPasswordToken = action.payload;
    },
    clearTempData: (state) => {
      state.tempEmail = undefined;
      state.tempToken = null;
      state.otpSent = false;
      state.forgotPasswordToken = undefined;
    },
    setTempToken: (state, action: PayloadAction<string>) => {
      state.tempToken = action.payload;
    },
  },
});

export const {
  setLoading,
  setAuth,
  logout,
  setTempEmail,
  setForgotPasswordToken,
  setOtpSent,
  clearTempData,
  setTempToken,
} = authSlice.actions;

export default authSlice.reducer;
